<template>
  <router-view class="container"></router-view>
</template>
